import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import * as actions from './actions';
import Alert from '../../components/alert';
import ModalButtons from './styled';
import Button from '../button';

class BaseAuth extends Component {
    static propTypes = {
        checkUserIsAuthorised: PropTypes.func,
        setAlertModalStatus: PropTypes.func,
        authorized: PropTypes.bool,
        displayModalStatus: PropTypes.bool,
        WrappedComponent: PropTypes.func
    };

    constructor(props) {
        super(props);

        const { checkUserIsAuthorised, authorized } = this.props;

        if (authorized == null) {
            checkUserIsAuthorised();
        }
    }

    handleModalButtonOnClick = () => {
        const { setAlertModalStatus } = this.props;

        setAlertModalStatus(false);
    }

    render() {
        const { authorized, WrappedComponent, displayModalStatus } = this.props;
        const modalButtons = (
            <ModalButtons>
                <Button handleOnClick={this.handleModalButtonOnClick} label="OK" primary />
            </ModalButtons>);

        if (authorized === true) {
            return <WrappedComponent {...this.props} />;
        }

        return (
            <Alert
                buttons={modalButtons}
                isActive={displayModalStatus}
                subTitle="You don't seem to have the right permissions to access this module!"
                title="Oops"
                warning
            />
        );
    }
}

export default function withAuth(WrappedComponent) {
    function mapStateToProps(state = null) {
        return {
            authorized: state.authorization.authorized,
            displayModalStatus: state.authorization.displayModalStatus,
            WrappedComponent
        };
    }

    function mapDispatchToProps(dispatch) {
        return bindActionCreators({
            checkUserIsAuthorised: actions.checkUserIsAuthorized,
            setAlertModalStatus: actions.setAlertModalStatus
        }, dispatch);
    }

    return connect(mapStateToProps, mapDispatchToProps)(BaseAuth);
}



// WEBPACK FOOTER //
// ./app/components/with-auth/index.js